import Header from "../../components/Header";
import SelectionsHeader from "../../components/SelectionsHeader";
import BetShuffle from "../BetShuffle";
import Filter from "../Filter";
import UpdateFavourites from "../UpdateFavourites";
import OnboardingPopup from "../../components/OnboardingPopup";

export default function DefaultLayout({
  toggleOnboarding,
  showOnboarding,
  closeOnboarding,
  children,
}) {
  return (
    <>
      {/* If the user hasn't gone through the onboarding process previously and there is no onboardingSeen 
              localStorage item that exists and if toggleOnboarding is true then the onboarding should display */}
      {toggleOnboarding ? (
        <OnboardingPopup close={() => closeOnboarding()} />
      ) : null}
      <Header
        toggleOnboarding={toggleOnboarding}
        showOnboarding={showOnboarding}
        closeOnboarding={closeOnboarding}
      />
      <SelectionsHeader />
      {children}
      <Filter />
      <BetShuffle />
      <UpdateFavourites />
    </>
  );
}
